<template>
  <v-dialog
    :model-value="modelValue"
    max-width="520"
    persistent
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card class="pa-2">
      <v-card-title class="text-h6 text-wrap">
        {{
          $t(
            mode === "accept"
              ? "workshop.accept_dialog.title"
              : "workshop.approve_dialog.title",
          )
        }}
      </v-card-title>
      <v-card-text>
        <v-alert
          v-if="error"
          type="error"
          variant="tonal"
          density="compact"
          class="mb-3"
        >
          {{ $t(error) }}
        </v-alert>

        <template v-if="mode === 'accept'">
          <div class="text-body-2 decision-wrap mb-1">
            <strong>{{ taskLabel }}</strong>
            <template v-if="reason"> · {{ reason }}</template>
          </div>
          <div class="text-body-2 text-medium-emphasis mb-3">
            {{ $t("workshop.accept_dialog.body") }}
          </div>
          <v-textarea
            v-model="note"
            variant="outlined"
            density="comfortable"
            rows="2"
            auto-grow
            :label="$t('workshop.accept_dialog.note')"
            :maxlength="noteMax"
            counter
          />
        </template>

        <template v-else>
          <div class="text-body-2 decision-wrap mb-2">
            {{ $t(approveBodyKey, { date: timing.dueDate }) }}
          </div>
          <div class="text-body-2 text-medium-emphasis">
            {{ $t("workshop.approve_dialog.read_only") }}
          </div>
        </template>
      </v-card-text>
      <v-card-actions class="flex-wrap justify-end ga-2">
        <v-btn
          variant="text"
          :disabled="saving"
          @click="$emit('update:modelValue', false)"
        >
          {{ $t("workshop.form.cancel") }}
        </v-btn>
        <v-btn
          color="green"
          variant="flat"
          :loading="saving"
          :disabled="saving"
          @click="$emit('confirm', note.trim())"
        >
          {{
            $t(
              mode === "accept"
                ? "workshop.accept_dialog.confirm"
                : "workshop.approve_dialog.confirm",
            )
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// The confirm dialog of "Accetta eccezione" (optional note) and "Approva bonifica" ("nei tempi" or
// "in ritardo", workshopDecisions.approvalTiming), Stage 3a slice 8. The parent runs the write
// through its checklist session and passes back the saving state and an error key.
// The API limit of the acceptance note.
const NOTE_MAX = 500;

export default {
  name: "WorkshopDecisionDialog",
  props: {
    modelValue: { type: Boolean, default: false },
    // "accept" | "approve"
    mode: { type: String, default: "accept" },
    // accept: the task label and the exception reason
    taskLabel: { type: String, default: "" },
    reason: { type: String, default: "" },
    // approve: { timing: "on_time" | "late", dueDate: "DD/MM/YYYY" | "" }
    timing: {
      type: Object,
      default: () => ({ timing: "on_time", dueDate: "" }),
    },
    saving: { type: Boolean, default: false },
    // An i18n key (workshopDecisions.decisionError), or ""
    error: { type: String, default: "" },
  },
  emits: ["update:modelValue", "confirm"],
  data: () => ({
    note: "",
    noteMax: NOTE_MAX,
  }),
  computed: {
    approveBodyKey() {
      if (this.timing.timing === "late") return "workshop.approve_dialog.late";
      return this.timing.dueDate
        ? "workshop.approve_dialog.on_time"
        : "workshop.approve_dialog.no_due_date";
    },
  },
  watch: {
    // A new dialog starts without a note.
    modelValue(open) {
      if (open) this.note = "";
    },
  },
};
</script>

<style scoped>
.decision-wrap {
  overflow-wrap: anywhere;
}
</style>
